import { render, staticRenderFns } from "./MyHome.vue?vue&type=template&id=fe1f58b2&scoped=true"
import script from "./MyHome.vue?vue&type=script&lang=js"
export * from "./MyHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1f58b2",
  null
  
)

export default component.exports